import { useState } from 'react';

import { useFetchOffers } from './hooks/useFetchOffers';

import styles from './styles.module.scss';
import { PageWrapper } from 'pages/Workshop/PageWrapper';
import { RevampedHeader } from '../components';
import classNames from 'classnames';
import { OffersActionButtons } from './components/OffersActionButtons';
import { setOffersFiltersEffect } from 'store/effects/offerAggregate';
import { PageSearchWrapper } from '../components/PageSearchWrapper';
import { OffersContent } from './components/OffersContent';

export const Offers = () => {
  const { offerAggregate, offersFilter, isPending, isFilterApplied } = useFetchOffers();
  const [isSearchActive, setSearchActive] = useState(false);

  return (
    <PageWrapper
      isContainer={false}
      isHideFooter
      pageWrapperContainerClassName={styles.mainPageContent}
    >
      <RevampedHeader
        className={classNames(styles.offersPageHeader, {
          [styles.activeSearchOffersPageHeader]: isSearchActive,
        })}
        title={'Offers'}
        titleClassName={styles.headerTitle}
        actionButtons={<OffersActionButtons onSearchClick={() => setSearchActive(true)} />}
      />

      <PageSearchWrapper
        isSearchActive={isSearchActive}
        resetAction={() => setOffersFiltersEffect({ ...offersFilter, searchString: '' })}
        sendAction={({ search }) =>
          setOffersFiltersEffect({ ...offersFilter, searchString: search })
        }
        otherSearchParams={{ offersFilter }}
        onCloseSearch={() => setSearchActive(false)}
      />

      <OffersContent
        isPending={isPending}
        offerAggregate={offerAggregate || []}
        showListView={isSearchActive || isFilterApplied}
        isSearchActive={isSearchActive}
      />
    </PageWrapper>
  );
};
